import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useContext } from 'react';
import { useUniformPersonalization } from './useUniformPersonalization';
import { ListScoring } from '@uniformdev/personalize';
import { SitecorePersonalizationContext } from './SitecorePersonalizationContext';
var formatSitecoreId = function formatSitecoreId(id) {
  return id && id.replace(/[^a-z0-9-]+/gi, "").toLocaleLowerCase();
};
var buildTrackingMetadata = function buildTrackingMetadata(route, rendering) {
  var response = {};
  if (route) {
    var name = route.name,
      itemId = route.itemId;
    response.page = {
      description: name,
      id: formatSitecoreId(itemId)
    };
  }
  if (rendering) {
    var dataSource = rendering.dataSource,
      componentName = rendering.componentName;
    response.component = {
      description: componentName,
      id: formatSitecoreId(dataSource)
    };
  }
  return response;
};
export var usePersonalizedList = function usePersonalizedList(props) {
  var _a;
  var conditions = props.conditions,
    list = props.list;
  var _useUniformPersonaliz = useUniformPersonalization(),
    visit = _useUniformPersonaliz.visit,
    visitor = _useUniformPersonaliz.visitor;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    personalizedList = _useState2[0],
    setPersonalizedList = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    wasPersonalized = _useState4[0],
    setWasPersonalized = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    refreshTrackingFlag = _useState6[0],
    setRefreshingTrackingFlag = _useState6[1];
  var context = useContext(SitecorePersonalizationContext);
  var testManager = (_a = context === null || context === void 0 ? void 0 : context.personalizationManager) === null || _a === void 0 ? void 0 : _a.testManager;
  useEffect(function () {
    var windowAny = window;
    if (windowAny.uniform && windowAny.uniform.visitor && windowAny.uniform.visit && !personalizedList) {
      var personalizer = new ListScoring({
        conditions: conditions,
        testManager: testManager,
        tracker: windowAny.uniform.tracker
      });
      var eventData = buildTrackingMetadata(props.route, props.rendering);
      // Once visitor and visit are initialized, execute personalization
      var _personalizer$execute = personalizer.execute(windowAny.uniform.visitor, windowAny.uniform.visit, list, eventData),
        items = _personalizer$execute.items,
        personalized = _personalizer$execute.personalized;
      // Store personalized list in state
      setPersonalizedList(items);
      setWasPersonalized(personalized);
    }
  }, [visit, visitor, list, refreshTrackingFlag]);
  var refreshTracking = function refreshTracking() {
    setPersonalizedList(null);
    setRefreshingTrackingFlag(new Date().valueOf());
  };
  return {
    personalizedList: personalizedList,
    wasPersonalized: wasPersonalized,
    refreshTracking: refreshTracking
  };
};